import React from 'react';

import { Button, EmptyState, Spinner } from '@ergeon/core-components';
import { ClipboardDocumentListIcon } from '@ergeon/icons/hero/outline';
import { PlusIcon } from '@ergeon/icons/hero/micro';

type NoActivitiesEmptyStateProps = {
  onGetActivity?: () => void;
  isLoading?: boolean;
  message?: string | null;
};

export const NoActivitiesEmptyState: React.FC<NoActivitiesEmptyStateProps> = ({
  onGetActivity,
  isLoading = false,
  message,
}) => (
  <div className="flex flex-col flex-grow justify-center items-center p-6 w-full">
    <EmptyState
      actions={onGetActivity ? (
        <Button
          aria-label="Get an activity from the queue"
          disabled={isLoading}
          flavor="regular"
          onClick={onGetActivity}
          size="medium"
          taste="line">
          {isLoading ? (
            <>
              <Spinner active className="shrink-0" />
              Getting...
            </>
          ) : (
            <>
              <PlusIcon className="size-4 shrink-0" />
              Get Activity
            </>
          )}
        </Button>
      ) : undefined}
      description={message || 'Activities will appear here when available.'}
      icon={<ClipboardDocumentListIcon />}
      title="No activities assigned" />
  </div>
);
